import { UI_BlurbCard } from 'ui/components/2-molecules/Card/BlurbCard/BlurbCard';

type Props = Content.GridCell & {
	documentType: 'blurbCard';
	content: {
		properties: {
			kicker: string;
			heading: string;
			text: string;
			link: Content.Link | null;
		};
	};
	settings: {
		properties: {
			displayLinkAsButton: boolean;
		};
	};
};

export const BlurbCard = ({ content }: Props) => <UI_BlurbCard {...content?.properties} />;
